export default __webpack_public_path__ + "static/media/officer.09617603.png";